(function () {
  var KEY = 'wp_wishlist_v1';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 2.6 4.5 6.3 4.5c2.1 0 3.8 1.2 5.7 3.4 1.9-2.2 3.6-3.4 5.7-3.4 3.7 0 5.4 3.9 3.9 7.3C19.5 16.4 12 21 12 21z"/></svg>';
  var drawer;

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function set(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }

  function refresh() {
    var list = get();
    document.querySelectorAll('.wpw-heart').forEach(function (b) {
      b.classList.toggle('is-on', list.indexOf(b.getAttribute('data-handle')) > -1);
    });
    document.querySelectorAll('.wpw-count').forEach(function (c) {
      c.textContent = list.length;
      c.style.display = list.length ? 'block' : 'none';
    });
  }

  function toggle(handle) {
    var l = get(), i = l.indexOf(handle);
    if (i > -1) l.splice(i, 1); else l.push(handle);
    set(l);
    refresh();
    if (drawer && drawer.classList.contains('is-open')) render();
  }

  function render() {
    var box = drawer.querySelector('.wpw-list'), list = get();
    if (!list.length) {
      box.innerHTML = '<p class="wpw-empty">No saved books yet. Tap the heart on any book to save it.</p>';
      return;
    }
    box.innerHTML = '<p class="wpw-empty">Loading…</p>';
    Promise.all(list.map(function (h) {
      return fetch(ROOT + 'products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      box.innerHTML = '';
      items.forEach(function (p) {
        if (!p) return;
        var d = document.createElement('div');
        d.className = 'wpw-item';
        d.innerHTML = '<img alt="" src="' + (p.featured_image || '') + '"><div><a href="' + ROOT + 'products/' + p.handle + '">' + p.title +
          '</a><div>Rs. ' + (p.price / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 }) +
          '</div><button type="button" data-wpw-remove="' + p.handle + '">Remove</button></div>';
        box.appendChild(d);
      });
    });
  }

  function openDrawer() {
    if (!drawer) {
      drawer = document.createElement('aside');
      drawer.className = 'wpw-drawer';
      drawer.innerHTML = '<div class="wpw-head">My wishlist <button type="button" data-wpw-close aria-label="Close">×</button></div><div class="wpw-list"></div>';
      document.body.appendChild(drawer);
    }
    render();
    drawer.classList.add('is-open');
  }

  function ensureHeaderLink() {
    if (document.querySelector('[data-wpw-open]')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wpw-link';
    b.setAttribute('data-wpw-open', '');
    b.setAttribute('aria-label', 'Open wishlist');
    b.innerHTML = HEART + '<span class="wpw-count" style="display:none">0</span>';
    document.body.appendChild(b);
  }

  function decorate() {
    document.querySelectorAll('.product-item').forEach(function (card) {
      if (card.getAttribute('data-wpw') || card.closest('sidebar-drawer')) return;
      var a = card.querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var host = card.querySelector('.inner_product_d') || card.querySelector('.lazy-image') || card;
      card.setAttribute('data-wpw', '1');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wpw-heart';
      b.setAttribute('data-handle', m[1]);
      b.setAttribute('aria-label', 'Save to wishlist');
      b.innerHTML = HEART;
      host.appendChild(b);
    });
    refresh();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var heart = t.closest('.wpw-heart');
    if (heart) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      toggle(heart.getAttribute('data-handle'));
      return;
    }
    if (t.closest('[data-wpw-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-wpw-close]')) { drawer.classList.remove('is-open'); return; }
    var rm = t.closest('[data-wpw-remove]');
    if (rm) { toggle(rm.getAttribute('data-wpw-remove')); }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer) drawer.classList.remove('is-open');
  });

  /* sticky header shadow */
  document.addEventListener('DOMContentLoaded', function () {
    var h = document.querySelector('.shopify-section:has(main-header)');
    if (!h) return;
    window.addEventListener('scroll', function () {
      h.classList.toggle('is-stuck', window.scrollY > 10);
    }, { passive: true });
  });

  function init() {
    ensureHeaderLink();
    decorate();
    window.addEventListener('load', decorate);
    setTimeout(decorate, 1500);
    setTimeout(decorate, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();